module.exports = __webpack_public_path__ + "static/media/sunset.75c1a533.jpg";